import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class KitQueryCriteriaClass extends BaseCriteriaModel {
  //bl_fi_inv_item_link table
  fi_item_hdr_guid?: Optional<string> = Optional.empty();
  fi_item_line_guid?: Optional<string> = Optional.empty();
  inv_item_hdr_guid?: Optional<string> = Optional.empty();
  inv_item_line_guid?: Optional<string> = Optional.empty();
  description?: Optional<string> = Optional.empty();
  txn_type?: Optional<string> = Optional.empty();
}

export class KitCriteriaModelQuery {
  query = '';

  constructor(KitCriteriaModel: KitQueryCriteriaClass) {

    if (!KitCriteriaModel) {
      return;
    }

    this.query += KitCriteriaModel.fi_item_hdr_guid.filter(x => x !== '').map(x => '&fi_item_hdr_guid=' + x).orElse('');
    this.query += KitCriteriaModel.fi_item_line_guid.filter(x => x !== '').map(x => '&fi_item_line_guid=' + x).orElse('');
    this.query += KitCriteriaModel.inv_item_hdr_guid.filter(x => x !== '').map(x => '&inv_item_hdr_guid=' + x).orElse('');
    this.query += KitCriteriaModel.inv_item_line_guid.filter(x => x !== '').map(x => '&inv_item_line_guid=' + x).orElse('');
    this.query += KitCriteriaModel.description.filter(x => x !== '').map(x => '&description=' + x).orElse('');
    this.query += KitCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');

    this.query += '&status=' + KitCriteriaModel.status;
    this.query += '&orderBy=' + KitCriteriaModel.orderBy;
    this.query += '&order=' + KitCriteriaModel.order;
    this.query += '&offset=' + KitCriteriaModel.offset + '&limit=' + KitCriteriaModel.limit;
  }
}
